
export const POST_LOGIN = "POST_LOGIN"
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS"
export const RESET_POST_LOGIN_STATE = "RESET_POST_LOGIN_STATE"
